<form class="example-form">
    <mat-form-field class="custom-comment-field" appearance="outline">
        <mat-label>Leave a comment</mat-label>
        <input matInput placeholder="Ex. Pizza">
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Leave a comment</mat-label>
        <textarea matInput placeholder="Ex. It makes me feel..."></textarea>
    </mat-form-field>
    <mat-checkbox class="example-margin">Check me!</mat-checkbox>

    <mat-form-field appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline" multiple>
        <mat-label>Choose an option</mat-label>
        <mat-select>
            <mat-option value="option1">Option 1</mat-option>
            <mat-option value="option2" disabled>Option 2 (disabled)</mat-option>
            <mat-option value="option3">Option 3</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-slide-toggle>Slide me!</mat-slide-toggle>

    <button mat-raised-button class="success-btn"><mat-icon>save</mat-icon> Save</button>
    <button mat-raised-button class="danger-btn"><mat-icon>close</mat-icon> Close</button>
    <a mat-raised-button class="primary-btn" href="https://www.google.com/" target="_blank">Link</a>
</form>